/**
 * Deep freeze function so we can freeze an object recursively.
 *
 * To be used for testing, mostly to make sure that we don't accidentally mutate
 * objects when we expect not to.
 *
 * Has some logic around typed arrays (which Decimal128 makes use of), which cannot be frozen
 * @param {Object} object Object to freeze
 * @returns {Object} - The frozen object (if possible)
 */
export function deepFreeze(object) {
  // Can't freeze a typed array, so we skip the object
  if (object && object.buffer instanceof ArrayBuffer) {
    return object;
  }

  Object.freeze(object);
  Object.getOwnPropertyNames(object).forEach(name => {
    const prop = object[name];

    // Freeze prop if it is an object
    if (typeof prop === 'object' && !Object.isFrozen(prop)) {
      deepFreeze(prop);
    }
  });

  return object;
}
